<template>
  <div class="p-reading-progress">
    <div class="p-reading-progress__bar" :style="{ width: `${progress}%` }" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const progress = ref(0)

const calculateProgress = () => {
  const windowHeight = window.innerHeight
  const documentHeight = document.documentElement.scrollHeight - windowHeight
  const scrollTop = window.scrollY
  progress.value = (scrollTop / documentHeight) * 100
}

onMounted(() => {
  window.addEventListener('scroll', calculateProgress)
})

onUnmounted(() => {
  window.removeEventListener('scroll', calculateProgress)
})
</script>
